import * as React from 'react';
import {
    Dialog, DialogTitle, DialogContent, Grid, IconButton
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { Link } from 'react-router-dom';
import { Guid } from 'guid-typescript';

export default class CountryModuleResponseComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
        }
        this.handleClose = this.handleClose.bind(this);
        this.getLinkAdminWise = this.getLinkAdminWise.bind(this);
    }

    handleClose = () => {
        this.props.onClose(this.props.modalState);
    }
    getLinkAdminWise = (mod: any) => {
        return <Link to={{ pathname: `/survey/response/` + mod.country_module_survey_mapping_id }}>
            <div className="media-body">
                <span className="mt-0">{mod.name}</span>
            </div>
            <div className="progress">
                <div className={mod.percentageCompleted === 100 ? "progress-bar progress-bar-success" : "progress-bar progress-bar-primary"}
                    style={{ width: (mod.percentageCompleted) + '%' }} role="progressbar" />

            </div>
        </Link>

    }

    render() {
        console.log("Render this.props.isAdmin: ", this.props.isAdmin)
        const countryModuleDetails = this.props.countryModuleDetails ?
            (this.props.moduleType === 2 ? this.props.countryModuleDetails.module_categories : this.props.countryModuleDetails.modules) : []

        return (
            <>
                <Dialog
                    fullWidth={this.state.fullWidth}
                    hideBackdrop={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.showDialog}
                    aria-labelledby="max-width-dialog-title"
                    className="applicationDialog"
                >

                    <div className="dialogWrapper">
                        <div className="dialogHead">
                            <DialogTitle id="max-width-dialog-title text-right" className="dialogTitle"> {this.props.country.name} :{this.props.moduleType === 2 ? "Coverage" : "Forecast"}
                                <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                    <CloseIcon />
                                </IconButton>
                                <hr className="HZDivider" />
                            </DialogTitle>
                        </div>

                        <div className="dialogContent">
                            <DialogContent>
                                <Grid container={true} spacing={40} direction="row" justify="center" alignItems="center">
                                    <Grid item={true} xs={12}>
                                        <Grid container={true} spacing={40}>
                                            {this.props.moduleType === 2 ? countryModuleDetails.map((subCat: any, key: any) => {
                                                return <>
                                                    <Grid item={true} xs={4} key={Guid.toString() + key}>
                                                        <div className="ModuleCat">
                                                            {subCat.name}
                                                        </div>
                                                    </Grid>
                                                    <Grid item={true} xs={8} key={Guid.toString()}>
                                                        <div className="ModuleName">
                                                            {subCat.modules.map((mod: any, modKey: any) => {
                                                                return <div className="media-content" key={modKey}>
                                                                    {this.getLinkAdminWise(mod)}
                                                                </div>
                                                            })}
                                                        </div>
                                                    </Grid>
                                                </>
                                            }) : countryModuleDetails.map((mod: any, key: any) => {
                                                return <Grid item={true} xs={12} key={Guid.toString() + key}>
                                                    <div className="ModuleName">
                                                        <div className="media-content">
                                                                <Link to={{ pathname: `/survey/response/` + mod.country_module_survey_mapping_id }}>
                                                                    <div className="media-body">
                                                                        <span className="mt-0">{mod.name}</span>
                                                                    </div>
                                                                    <div className="progress">
                                                                        <div className={mod.percentageCompleted === 100 ? "progress-bar progress-bar-success" : "progress-bar progress-bar-primary"}
                                                                            style={{ width: (mod.percentageCompleted) + '%' }} role="progressbar" />

                                                                    </div>
                                                                </Link> 
                                                        </div>
                                                    </div>
                                                </Grid>
                                            })}
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </DialogContent>
                        </div>

                        {/* <div className="dialogAction">
                            <hr className="HZDivider" />
                            <DialogActions>
                                <Button color="primary" className="btn-blue-primary" onClick={this.handleApplyChanges}>
                                    Apply Rule &nbsp; >
                                </Button>
                            </DialogActions>
                        </div> */}

                    </div>
                </Dialog>
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AdminDashboardResponse/CountryModuleResponseComponent.tsx